import { TicketForm } from '@/components/tickets/ticket-form'
import { TicketList } from '@/components/tickets/ticket-list'
import { TicketSummary, TicketStats } from '@/components/tickets/ticket-summary'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Mail, ExternalLink } from 'lucide-react'

export function EmailDrafterTickets() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-background font-sans">

      {/* Minimalist Header */}
      <div className="bg-card dark:bg-card border-b border-border py-4 mb-6">
        <div className="max-w-[1200px] mx-auto px-4">
          <div className="flex items-center justify-between flex-wrap gap-4">
            <div className="flex items-center gap-3">
              <img
                src="/ms_icon_light.svg"
                alt="Mission Solar"
                className="w-8 h-8"
              />
              <div className="flex items-center gap-2">
                <h1 className="text-xl font-semibold text-foreground">
                  EmailDrafter
                </h1>
                <span className="bg-amber-500 dark:bg-amber-600 text-white text-[10px] font-bold tracking-wider px-2 py-1 rounded uppercase">
                  BETA
                </span>
                <h1 className="text-xl font-semibold text-foreground">
                  - Tickets
                </h1>
              </div>
            </div>
            <div className="flex gap-6 flex-wrap">
              <a href="/admin/email-drafter" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground hover:underline transition-colors">
                <Mail className="h-4 w-4" />
                EmailDrafter Testing
                <ExternalLink className="h-3 w-3" />
              </a>
              <a href="/public" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground hover:underline transition-colors">
                Knowledge Base
                <ExternalLink className="h-3 w-3" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-[1200px] mx-auto px-4 pb-6">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_2fr] gap-6">
          {/* Left Column - Summary & Form */}
          <div className="space-y-4">
            {/* Ticket Summary - Activity sections */}
            <TicketSummary />

            <Card>
              <CardHeader className="pb-3">
                <CardTitle className="text-lg font-semibold text-foreground">
                  Neues Ticket erstellen
                </CardTitle>
              </CardHeader>
              <CardContent>
                <TicketForm />
              </CardContent>
            </Card>

            {/* Statistics after Form */}
            <TicketStats />

            {/* Compact Info Card */}
            <Card>
              <CardHeader className="pb-2">
                <CardTitle className="text-base font-medium text-foreground">
                  So funktioniert's
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-2 text-sm text-muted-foreground">
                <div className="flex gap-2">
                  <span className="w-5 h-5 bg-muted dark:bg-muted text-muted-foreground rounded-full flex items-center justify-center text-xs font-medium flex-shrink-0 mt-0.5">
                    1
                  </span>
                  <p>Ticket mit detaillierter Beschreibung erstellen</p>
                </div>
                <div className="flex gap-2">
                  <span className="w-5 h-5 bg-muted dark:bg-muted text-muted-foreground rounded-full flex items-center justify-center text-xs font-medium flex-shrink-0 mt-0.5">
                    2
                  </span>
                  <p>Team bearbeitet Ticket und stellt Lösung bereit</p>
                </div>
                <div className="flex gap-2">
                  <span className="w-5 h-5 bg-muted dark:bg-muted text-muted-foreground rounded-full flex items-center justify-center text-xs font-medium flex-shrink-0 mt-0.5">
                    3
                  </span>
                  <p>Automatische E-Mail mit Lösung an Firmen-Adresse</p>
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Right Column - Ticket List */}
          <div>
            <Card>
              <CardHeader className="pb-3">
                <CardTitle className="text-lg font-semibold text-foreground">
                  Alle Tickets
                </CardTitle>
              </CardHeader>
              <CardContent>
                <TicketList />
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </div>
  )
}